import React, { memo } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export const GuaranteeSection = memo(function GuaranteeSection() {
  return <section className="py-16 px-4 bg-gray-950 border-t border-gray-800" data-id="element-94">
      <div className="max-w-xl mx-auto text-center" data-id="element-95">

        {/* Icon */}
        <div className="inline-flex items-center justify-center p-4 bg-green-500/10 rounded-full mb-6 border border-green-500/20" data-id="element-96">
          <ShieldCheckIcon className="w-10 h-10 text-green-500" data-id="element-97" />
        </div>

        {/* Headline */}
        <h2 className="text-[24px] md:text-3xl font-black text-white leading-tight mb-4" data-id="element-98">
          Tu inversión está{' '}
          <span className="text-green-500" data-id="element-99">100% protegida</span>
        </h2>

        {/* Card */}
        <div className="bg-green-500/5 border border-green-500/20 rounded-2xl p-6 text-left mb-6" data-id="element-100">
          <p className="text-gray-300 text-[14px] md:text-base leading-relaxed mb-5 text-center" data-id="element-101">
            Si en los próximos <strong className="text-white" data-id="element-102">30 días</strong> no aprendés o el producto no cumple tus expectativas, te devolvemos el <strong className="text-white" data-id="element-103">100% de tu dinero</strong>. Sin preguntas. Sin formularios.
          </p>

          <div className="grid grid-cols-2 gap-3" data-id="element-104">
            {[{
            icon: '✅',
            text: '30 días de garantía'
          }, {
            icon: '✅',
            text: '100% de devolución'
          }, {
            icon: '✅',
            text: 'Sin preguntas'
          }, {
            icon: '✅',
            text: 'Respuesta en 48hs'
          }].map((item, i) => <div key={i} className="flex items-center gap-2 text-[13px] text-gray-300" data-id="element-105">
                <span data-id="element-106">{item.icon}</span>
                <span data-id="element-107">{item.text}</span>
              </div>)}
          </div>

          <div className="mt-5 pt-4 border-t border-green-500/20 text-center" data-id="element-108">
            <p className="text-gray-400 text-[12px]" data-id="element-109">
              Soporte:{' '}
              <strong className="text-blue-400" data-id="element-110">construyeprogresoo@gmail.com</strong>
            </p>
          </div>
        </div>

        {/* Cierre */}
        <p className="text-gray-400 text-[14px] md:text-base" data-id="element-111">
          No tenés nada que perder.{' '}
          <strong className="text-white" data-id="element-112">El único riesgo real es seguir donde estás.</strong>
        </p>
      </div>
    </section>;
});